type RecipeListingPageLayoutProps = {
  error: unknown;
  gridType: 'recipe-cards' | 'featured';
  disableFilters: boolean;
  disableSortBy: boolean;
  gridTitle: string;
  gridSubtitle: string;
  preloadImages: boolean;
  filterComponent: React.ReactNode;
  sortByComponent: React.ReactNode;
  recipeCardGrid: React.ReactNode;
};

const RecipeListingPageLayout = ({
  error,
  filterComponent,
  sortByComponent,
  recipeCardGrid,
  gridTitle,
  gridSubtitle,
}: RecipeListingPageLayoutProps) => {
  if (error) return <div data-testid="recipe-grid-error">Failed to load recipes</div>;

  return (
    <div>
      <h1>{gridTitle}</h1>
      <p>{gridSubtitle}</p>
      {filterComponent}
      {sortByComponent}
      {recipeCardGrid}
    </div>
  );
};

export default RecipeListingPageLayout;
